module.exports = __webpack_public_path__ + "static/media/menu-landing-pages-twitter.728531c9.svg";